// extracted by mini-css-extract-plugin
export default {"container":"AltTextInput_container__zouNP"};